import React, {Component} from 'react';
import { Route, Switch, Link, BrowserRouter as Router } from 'react-router-dom'
import './App.css';
import ScrollToTop from './ScrollToTop.js'
import Navbar from './components/Navbar/Navbar';
import NavbarDrawer from './components/NavbarDrawer/NavbarDrawer';
import Backdrop from './components/Backdrop/Backdrop';
import Footer from './components/Footer/Footer';

import MainSite from './components/MainSite/MainSite';

import IAgriculture from './components/IndividualPages/IAgriculture/IAgriculture';
import IEnergy from './components/IndividualPages/IEnergy/IEnergy';
import IHealthcare from './components/IndividualPages/IHealthcare/IHealthcare';
import IRealestate from './components/IndividualPages/IRealestate/IRealestate';

import INetwork from './components/IndividualPages/INetwork/INetwork';
import ICompanyProfile from './components/IndividualPages/ICompanyProfile/ICompanyProfile';

import Provider from './components/IndividualPages/IHealthcare/Cards/Provider/Provider';

import Reforestation from './components/IndividualPages/IAgriculture/Cards/Reforestation/Reforestation';

import Advisory from './components/IndividualPages/IRealestate/Cards/Advisory/Advisory';
import DesignAndBuild from './components/IndividualPages/IRealestate/Cards/DesignAndBuild/DesignAndBuild';
import PropertyInvestment from './components/IndividualPages/IRealestate/Cards/PropertyInvestment/PropertyInvestment';

//import IContact from './components/IndividualPages/IContact/IContact';

class App extends Component {
	state = {
		drawerOpen: false
	};

	drawerToggleClickHandler = () => {
		this.setState((prevState) => {
			return {drawerOpen: !prevState.drawerOpen};
		});
	};

	backdropClickHandler = () => {
		this.setState({drawerOpen: false});
	}

	render() {
		let backdrop;
		if (this.state.drawerOpen) {
			backdrop = <Backdrop click={this.backdropClickHandler}/>;
		}
		return (
			<Router>
				<ScrollToTop>
					<div className="App">
						<Navbar drawerClickHandler={this.drawerToggleClickHandler} />
						<NavbarDrawer show={this.state.drawerOpen} drawerClickHandler={this.drawerToggleClickHandler}/>
						{backdrop}
						<Switch>
							<Route exact path="/" component={MainSite} />
							<Route path="/agriculture/reforestation" component={Reforestation} />
							<Route path="/agriculture" component={IAgriculture} />
							<Route path="/energy" component={IEnergy} />
							<Route path="/healthcare/provider" component={Provider} />
							<Route path="/healthcare" component={IHealthcare} />
							<Route path="/realestate/advisory" component={Advisory} />
							<Route path="/realestate/design" component={DesignAndBuild} />
							<Route path="/realestate/investment" component={PropertyInvestment} />
							<Route path="/realestate" component={IRealestate} />
							<Route path="/network" component={INetwork} />
							<Route path="/companyprofile" component={ICompanyProfile} />
						</Switch>
						<Footer />
					</div>
				</ScrollToTop>
			</Router>
		);
	}
}

export default App;
